import { render, staticRenderFns } from "./StatusPrioridade.vue?vue&type=template&id=ef2f241a&"
import script from "./StatusPrioridade.vue?vue&type=script&lang=js&"
export * from "./StatusPrioridade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports